import { Cents, Money, formatMoney, toMoney } from '@betterment/js-runtime';

export function estimatedShares(orderAmountCents: Cents | undefined, price: Money) {
  if (!orderAmountCents) return undefined;
  const shares = toMoney(orderAmountCents).dollars / price.dollars;
  const precision = shares < 0.1 ? 6 : 2;
  return Math.trunc(shares * 10 ** precision) / 10 ** precision;
}

export function estimatedSharesCopy(orderAmountCents: Cents | undefined, price: Money) {
  if (!orderAmountCents) return '';
  const shares = estimatedShares(orderAmountCents, price);
  return `Est. ${shares} shares at ${formatMoney(price)}/share`;
}

export function estimatedMoneyAmount(orderAmount: number | undefined, price: Money) {
  if (!orderAmount) return undefined;
  return toMoney(price.cents * orderAmount);
}

export function estimatedMoneyAmountCopy(orderAmount: number | undefined, price: Money) {
  if (!orderAmount) return '';
  const estimatedAmount = estimatedMoneyAmount(orderAmount, price);
  if (!estimatedAmount) return '';
  return `Est. ${formatMoney(estimatedAmount)} at ${formatMoney(price)}/share`;
}
